import { Component, effect, inject, input, model, output } from '@angular/core';
import {
  AvatarComponent,
  BadgeComponent,
  ClickOutSideDirective,
  LogoutIconComponent,
} from '@mars/ui-components';
import { AuthService } from '../../services/auth/auth.service';
import { RouteStrategyFactory } from '../../guards/user-strategies/route-strategy.factory';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'mars-user-info',
  standalone: true,
  imports: [
    AvatarComponent,
    ClickOutSideDirective,
    BadgeComponent,
    TranslocoModule,
    LogoutIconComponent,
  ],
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.scss',
})
export class UserInfoComponent {
  logout = output();
  isLoggingOut = input(false);

  protected readonly authService = inject(AuthService);
  showDropdown = model(false);

  protected userType: string | null = null;

  userTypeEffect = effect(() => {
    const userType = this.authService.userType();
    const state = userType?.user;
    this.userType = state
      ? RouteStrategyFactory.getStrategy(state).title
      : null;
  });

  userLogout() {
    if (!this.isLoggingOut()) this.logout.emit();
  }
}
